<template>
  <div v-if="expiration">
    <b-modal
      v-model="modalShow"
      hide-header
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <!-- Password modal -->
      <div class="form-container">
        <p class="text-capitalize-first filterTittle">
          {{ $t("share_video_link.modal_title") }}
        </p>
        <validation-observer v-slot="{ handleSubmit }">
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="handleSubmit(onCheckPassword)"
            ref="formPassword"
          >
            <validation-provider
              :name="$t('share_video_link.password')"
              rules="required"
              v-slot="{ errors }"
            >
              <b-form-group class="text-capitalize-first" label-for="password">
                <b-form-input
                  type="password"
                  v-model="password"
                  trim
                  :state="errors.length > 0 ? false : null"
                />
                <p v-if="errors" class="small text-danger text-capitalize-first mt-1">
                  {{ errors[0] }}
                </p>
                <p v-if="!valid" class="small text-danger text-capitalize-first mt-1">
                  {{ message }}
                </p>
              </b-form-group>
            </validation-provider>

            <b-button
              variant="primary"
              class="mb-1 text-capitalize-first float-right"
              type="submit"
            >
              {{ $t("actions.accept") }}
            </b-button>
          </b-form>
        </validation-observer>
      </div>
    </b-modal>
    <div v-if="videoShow" class="stream-video" style="width: 100vw; height: 100vh"></div>
  </div>
  <div
    v-else
    class="fullscreen-container d-flex justify-content-center align-items-center"
  >
    <div
      v-if="!expiration"
      class="d-flex justify-content-center flex-column align-items-center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        width="100"
        height="100"
        class="mb-2"
      >
        <path
          d="M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1c0 1.43-.98 2.63-2.31 2.98l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5zm-1 4h-2.19l2 2H16zM2 4.27l3.11 3.11A4.991 4.991 0 0 0 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1c0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74L3.27 3L2 4.27z"
          fill="red"
        ></path>
      </svg>
      <div class="text-white display-4 margin-auto text-capitalize-first">
        {{ $t("share_video_link.expired_link") }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ref, onMounted, nextTick } from "@vue/composition-api";
import CamerasSdk from "@omnicloud/cameras-sdk-v2";
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.full.esm";
import formValidation from "@core/comp-functions/forms/form-validation";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import router from "@/router";
import axios from "@axios";
import moment from "moment";

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    ValidationProvider,
    ValidationObserver,
    formValidation,
  },
  setup(_, context) {
    onMounted(() => {
      getSharedVideoLink(params);
    });

    const params = router.currentRoute.params.data;
    const password = ref("");
    const modalShow = ref(false);
    const videoShow = ref(false);
    const valid = ref(false);
    const data = ref([]);
    const expiration = ref(true);
    const message = ref("");
    const omniviewCamera = ref(null);
    const invalidApiResponse = ref(false);
    const stream_video = document.querySelector(".stream-video");
    const { t } = useI18nUtils();
    const trans = {
      "share_video_link.expired_link": t("share_video_link.expired_link"),
      "share_video_link.password_error": t("share_video_link.password_error"),
    };

    const getSharedVideoLink = (params) => {
      axios
        .get(`${window.__env.VUE_APP_BASE_URL}/v1/share_video_link/${params}`)
        .then((response) => {
          if (response.data.success) {
            data.value = response.data;
            if (response.data.password) {
              modalShow.value = true;
            } else {
              videoShow.value = true;
              recording(data);
              validateTime();
            }
          } else {
            router.push({ name: "home" });
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.response && error.response.status >= 400) {
            message.value = trans["share_video_link.expired_link"];
            expiration.value = false;
          }
        });
    };

    const onCheckPassword = () => {
      if (password.value.length > 0) {
        axios
          .post(
            `${window.__env.VUE_APP_BASE_URL}/v1/share_video_link/verify_password/${data.value.id}`,
            {
              password: password.value,
            }
          )
          .then((response) => {
            if (response.data.success) {
              modalShow.value = false;
              videoShow.value = true;
              recording(data);
              validateTime();
            } else {
              message.value = trans["share_video_link.password_error"];
              valid.value = false;
            }
          });
      }
    };

    const recording = (data) => {
      let config = {
        id: "shared_video",
        cameraId: data.value.camera_proxy.id,
        container: `.stream-video`,
        token: data.value.token,
        apiUrl: `${window.__env.VUE_APP_BASE_URL}/v1`,
        pusher_app_key: window.__env?.VUE_APP_LARAVEL_PUSHER_APP_KEY,
        pusher_host: window.__env?.VUE_APP_LARAVEL_PUSHER_HOST,
        pusher_port: window.__env?.VUE_APP_LARAVEL_PUSHER_PORT,
        pusher_app_cluster: window.__env.VUE_APP_LARAVEL_PUSHER_APP_CLUSTER || "mt1",
        startDate: null,
        endDate: null,
        mode: "live_video",
        layout: "shared_video",
        tz: data.value?.data?.tz
      };

      if (data.value.start_date && data.value.end_date) {
        config.startDate = data.value.start_date;
        config.endDate = data.value.end_date;
        config.mode = "recorded_video";
      }

      if(typeof data.value.download !== 'undefined') {
        config.download = data.value.download
      }

      nextTick(() => {
        omniviewCamera.value = new CamerasSdk(config);
      });
    };

    const validateTime = () => {
      setInterval(() => {
        let todayUTCString = moment.utc().format("YYYY-MM-DD HH:mm:ss");
        let expirationDateUTCString = data.value.expiration_date;
        expiration.value = true;

        if (moment(todayUTCString).isAfter(expirationDateUTCString)) {
          omniviewCamera.value?.destroy();
          message.value = trans["share_video_link.expired_link"];
          expiration.value = false;
          clearInterval(validateTime);
        }
      }, 1000);
    };

    return {
      password,
      recording,
      videoShow,
      modalShow,
      onCheckPassword,
      message,
      expiration,
      valid,
    };
  },
};
</script>

<style lang="scss" scoped>
.filterTittle {
  font-size: 1.2rem;
  color: #1b3d5e;
  margin-bottom: 0;
}

.text-capitalize-first {
  text-transform: lowercase;

  &:first-letter {
    text-transform: uppercase;
  }
}

.form-container {
  max-width: 400px;
  margin: auto;
}

.fullscreen-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #1b3d5e;
}
</style>
